import React, {useMemo} from 'react';
import { string, object, oneOfType, array } from 'prop-types';
import classNames from 'classnames/bind';
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion';
import 'react-accessible-accordion/dist/fancy-example.css';

import TabAbout from '../TabAbout';
import TabOeNumbers from '../TabOeNumbers';
import TabLinkedVehicles from '../TabLinkedVehicles';
import TabPartList from '../TabPartList';
import TabReferenceReplaceList from '../TabReferenceReplaceList';
import { withLabels } from 'containers/withLabels';
import TabResources from 'pages/Product/components/TabResources';

import { changeRoute } from 'utils/tabsHelper';
import { VALEO_BRANDS, getIsValeoBrand } from 'utils/constantsHelper';

import IconArrowRight from 'media/icons/arrow-down.icon.svg';
import styles from './ProductAccordion.module.scss';
const cx = classNames.bind(styles);

const ProductAccordion = ({
  className,
  data,
  match,
  labels,
  dataBulletins,
}) => {
  const documents = data.product.articleDocuments.array
    ? data.product.articleDocuments.array.filter((item) => item.docTypeId === 4)
    : [];
  const { brandNo } = data.product.assignedArticle || {};

  const isValeoProduct = useMemo(() => getIsValeoBrand(VALEO_BRANDS, Number(brandNo)), [VALEO_BRANDS, brandNo]);
  const isDisplayTechDocs =
    isValeoProduct && (dataBulletins.length || documents.length);

  const handleAccordionChange = (tabName) => {
    changeRoute(tabName);
  };
  const { hasPartList, articleId } = data.product.assignedArticle;

  const productsReplaces = useMemo(() => {
    const references = data.product.replacedNumber.array;
    return references ? references.filter(ref => ref.replaceArticleId) : null;
  }, [data]);

  const productsReplacedBy = useMemo(() => {
    const references = data.product.replacedByNumber.array;
    return references ? references.filter(ref => ref.replaceArticleId) : null;
  }, [data]);

  return (
    <Accordion
      className={className}
      preExpanded={[match.params.tabName]}
      allowZeroExpanded={true}
      onChange={handleAccordionChange}
    >
      <AccordionItem uuid={'about'}>
        <AccordionItemHeading>
          <AccordionItemButton className={cx('item-mobile')}>
            {labels.productAboutTab}
            <span className={cx('icon')}>
              <IconArrowRight />
            </span>
          </AccordionItemButton>
        </AccordionItemHeading>

        <AccordionItemPanel>
          {data.product && data.product.articleAttributes ? (
            <TabAbout data={data.product.articleAttributes.array} />
          ) : null}
        </AccordionItemPanel>
      </AccordionItem>
      {!!isDisplayTechDocs && (
        <AccordionItem uuid={'technical-resources'}>
          <AccordionItemHeading>
            <AccordionItemButton className={cx('item-mobile')}>
              {labels.productResourcesTab + ' '}(
              {dataBulletins.length + documents.length})
              <span className={cx('icon')}>
                <IconArrowRight />
              </span>
            </AccordionItemButton>
          </AccordionItemHeading>

          <AccordionItemPanel>
            <TabResources data={dataBulletins} documents={documents} />
          </AccordionItemPanel>
        </AccordionItem>
      )}
      {data.product.oenNumbers && (
        <AccordionItem uuid={'oe-numbers'}>
          <AccordionItemHeading>
            <AccordionItemButton className={cx('item-mobile')}>
              {labels.productOeNumbersTab}
              <span className={cx('icon')}>
                <IconArrowRight />
              </span>
            </AccordionItemButton>
          </AccordionItemHeading>

          <AccordionItemPanel>
            <TabOeNumbers dataOeNumbers={data.product.oenNumbers.array} />
          </AccordionItemPanel>
        </AccordionItem>
      )}
      <AccordionItem uuid={'linked-vehicles'}>
        <AccordionItemHeading>
          <AccordionItemButton className={cx('item-mobile')}>
            {labels.productLinkedVehiclesTab}
            <span className={cx('icon')}>
              <IconArrowRight />
            </span>
          </AccordionItemButton>
        </AccordionItemHeading>
        <AccordionItemPanel>
          <TabLinkedVehicles
            dataOeNumbers={data.product.oenNumbers.array}
            productId={articleId}
          />
        </AccordionItemPanel>
      </AccordionItem>
      {hasPartList && (
        <AccordionItem uuid={'parts-list'}>
          <AccordionItemHeading>
            <AccordionItemButton className={cx('item-mobile')}>
              {labels.productPartsListTab}
              <span className={cx('icon')}>
                <IconArrowRight />
              </span>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel>
            <TabPartList articleId={articleId} />
          </AccordionItemPanel>
        </AccordionItem>
      )}
      {productsReplaces && productsReplaces.length > 0 && (
        <AccordionItem uuid="replaces">
          <AccordionItemHeading>
            <AccordionItemButton className={cx('item-mobile')}>
              {labels.replacesLabel}
              <span className={cx('icon')}>
                <IconArrowRight />
              </span>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel>
          <TabReferenceReplaceList references={productsReplaces} />
          </AccordionItemPanel>
        </AccordionItem>
      )}
      {productsReplacedBy && productsReplacedBy.length > 0 && (
        <AccordionItem uuid="replaced-by">
          <AccordionItemHeading>
            <AccordionItemButton className={cx('item-mobile')}>
              {labels.replacedLabel}
              <span className={cx('icon')}>
                <IconArrowRight />
              </span>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel>
          <TabReferenceReplaceList references={productsReplacedBy} />
          </AccordionItemPanel>
        </AccordionItem>
      )}
    </Accordion>
  );
};

ProductAccordion.propTypes = {
  data: object.isRequired,
  match: object.isRequired,
  dataBulletins: oneOfType([object, array]).isRequired,
  className: string,
  labels: object.isRequired,
};

ProductAccordion.defaultProps = {
  className: null,
};

export default withLabels(ProductAccordion);



// WEBPACK FOOTER //
// ./src/pages/Product/components/ProductAccordion/ProductAccordion.js